// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"536":"1fed6d10","775":"1fed6d10"}[chunkId] + ".chunk.css";
};